<template>
  <div class="store-picker-modal">
    <modal
      v-if="active"
      v-model="active"
      title="Välj butik"
    >
      <template #belowHeader>
        <tabs
          :tabs="[tabNames.yourStores, tabNames.findStore]"
          :active-tab="activeTab"
          @tabChange="changeTab"
        />
      </template>

      <template #content>
        <your-stores-tab
          v-show="activeTab === tabNames.yourStores"
          :key="tabNames.yourStores"
          :current-store-id="currentStoreId"
          @toggleModal="active = $event"
          @selectedStore="selectStore('dina butiker', ...arguments)"
        />
        <find-store-tab
          v-show="activeTab === tabNames.findStore"
          :key="tabNames.findStore"
          :active-tab="activeTab === tabNames.findStore"
          :current-store-id="currentStoreId"
          @selectedStore="selectStore('hitta butik', ...arguments)"
        />
      </template>
    </modal>
  </div>
</template>

<script>
import ga from '@/analytics/dataLayerTopNav.js'
import tabs from '@/vue/components/common/tabs'
import yourStoresTab from './yourStoresTab'
import findStoreTab from './findStoreTab'
import modal from './modal'

export default {
  name: 'StorePickerModal',
  components: {
    yourStoresTab,
    findStoreTab,
    tabs,
    modal
  },
  model: {
    prop: 'active',
    event: 'openstate'
  },
  props: {
    currentStoreId: {
      type: String,
      default: ""
    }
  },
  data () {
    return {
      tabNames: {
        yourStores: 'Dina butiker',
        findStore: 'Hitta butik'
      },
      searchQuery: '',
      active: true,
      stores: null,
      error: null,
      loading: false,
      activeTab: 'Dina butiker'
    }
  },
  watch: {
    active: function (newVal) {
      if (!newVal) {
        this.$emit('openstate', false)
      }
    }
  },
  methods: {
    changeTab (tab) {
      this.activeTab = tab
    },
    selectStore (tab, store) {
      ga.selectNewStore(store, tab)
      this.$emit('update-selected-store', store)
      this.$emit('openstate', false)
    }
  }
}
</script>

<style lang="scss">
  .store-picker-modal {
    .e6-modal-content__inner {
      height: 100%;
    }

    @include media-breakpoint-up(md) {
      .e6-modal-content__inner {
        height: auto;
      }

      .e6-modal-container {
        max-height: calc(100% - 15px);
        height: 650px;
      }
    }

    .tabs-fade-enter-active,
    .tabs-fade-leave-active {
      transition: opacity 0.1s;
    }

    .tabs-fade-enter,
    .tabs-fade-leave-to {
      opacity: 0;
    }
  }
</style>
